import { ColumnDefinition } from '../../../sharedComponents/table/SortedTableHeader';

export enum DepartedVehiclesTableColumn {
    VIN = 'vin',
    LOAD_ID = 'loadId',
    LOCATION_ID = 'locationId',
    LOCATION_CITY = 'locationCity',
    MANUFACTURER = 'manufacturer',
    MODEL = 'model',
    DISPATCH_TYPE = 'dispatchType',
    FUEL_TYPE = 'fuelType',
    MODEL_VERSION = 'modelVersion',
    SPECIAL_INSTRUCTIONS = 'specificationInstructions',
    ARRIVAL_DATE = 'arrivalDate',
    ARRIVAL_FROM_LOCATION_ID = 'arrivalFromLocationId',
    ARRIVAL_FROM_CITY = 'arrivalFromCity',
    ARRIVAL_FREIGHT_FORWARDER = 'arrivalFreightForwarder',
    DEPARTURE_DATE = 'departureDate',
    DEPARTURE_TO_LOCATION_ID = 'departureToLocationId',
    DEPARTURE_TO_CITY = 'departureToCity',
    DEPARTURE_FREIGHT_FORWARDER = 'departureFreightForwarder',
    ACTION = 'action',
}

export const departedVehiclesColumnDefinition: ColumnDefinition<DepartedVehiclesTableColumn>[] = [
    {
        column: DepartedVehiclesTableColumn.VIN,
        labelId: 'outboundOrderBook.common.heading.vin',
        sortable: false,
        alwaysVisible: true,
    },
    {
        column: DepartedVehiclesTableColumn.LOAD_ID,
        labelId: 'outboundOrderBook.compoundManagement.table.heading.loadId',
        sortable: false,
    },
    {
        column: DepartedVehiclesTableColumn.LOCATION_ID,
        labelId: 'outboundOrderBook.compoundManagement.table.heading.locationId',
        sortable: true,
    },
    {
        column: DepartedVehiclesTableColumn.LOCATION_CITY,
        labelId: 'outboundOrderBook.compoundManagement.table.heading.location',
        sortable: false,
    },
    {
        column: DepartedVehiclesTableColumn.MANUFACTURER,
        labelId: 'outboundOrderBook.common.heading.manufacturer',
        sortable: false,
    },
    {
        column: DepartedVehiclesTableColumn.MODEL,
        labelId: 'outboundOrderBook.common.heading.model',
        sortable: false,
    },
    {
        column: DepartedVehiclesTableColumn.DISPATCH_TYPE,
        labelId: 'outboundOrderBook.common.heading.vehicleType',
        sortable: false,
    },
    {
        column: DepartedVehiclesTableColumn.FUEL_TYPE,
        labelId: 'outboundOrderBook.common.heading.fuelType',
        sortable: false,
    },
    {
        column: DepartedVehiclesTableColumn.MODEL_VERSION,
        labelId: 'outboundOrderBook.compoundManagement.table.heading.modelVersion',
        sortable: false,
    },
    {
        column: DepartedVehiclesTableColumn.SPECIAL_INSTRUCTIONS,
        labelId: 'outboundOrderBook.common.vehicle.specialInstructions',
        sortable: false,
    },
    {
        column: DepartedVehiclesTableColumn.ARRIVAL_DATE,
        labelId: 'outboundOrderBook.compoundManagement.table.heading.arrivalDate',
        sortable: true,
    },
    {
        column: DepartedVehiclesTableColumn.ARRIVAL_FROM_LOCATION_ID,
        labelId: 'outboundOrderBook.compoundManagement.table.heading.arrivalFromLocationId',
        sortable: false,
    },
    {
        column: DepartedVehiclesTableColumn.ARRIVAL_FROM_CITY,
        labelId: 'outboundOrderBook.compoundManagement.table.heading.arrivalFromCity',
        sortable: false,
    },
    {
        column: DepartedVehiclesTableColumn.ARRIVAL_FREIGHT_FORWARDER,
        labelId: 'outboundOrderBook.compoundManagement.table.heading.arrivalCarrier',
        sortable: true,
    },
    {
        column: DepartedVehiclesTableColumn.DEPARTURE_DATE,
        labelId: 'outboundOrderBook.compoundManagement.table.heading.departureDate',
        sortable: true,
    },
    {
        column: DepartedVehiclesTableColumn.DEPARTURE_TO_LOCATION_ID,
        labelId: 'outboundOrderBook.compoundManagement.table.heading.departureToLocationId',
        sortable: false,
    },
    {
        column: DepartedVehiclesTableColumn.DEPARTURE_TO_CITY,
        labelId: 'outboundOrderBook.compoundManagement.table.heading.departureToCity',
        sortable: false,
    },
    {
        column: DepartedVehiclesTableColumn.DEPARTURE_FREIGHT_FORWARDER,
        labelId: 'outboundOrderBook.compoundManagement.table.heading.departureCarrier',
        sortable: true,
    },
    {
        column: DepartedVehiclesTableColumn.ACTION,
        labelId: 'outboundPortal.compoundManagement.table.heading.action',
        sortable: false,
    },
];
